import { __decorate } from "tslib";
import Component from "vue-class-component";
import Task from "@/services/task";
import ReactiveComponent from "@/components/ReactiveComponent";
import TemplateContent from "@/components/template/TemplateContent.vue";
import ScheduleBoard from "@/components/ScheduleBoard.vue";
import ProgressButton from "@/components/ProgressButton.vue";
import gql from "graphql-tag";
import trainingService from "@/services/trainingService";
class BoardWithDaysOff {
    constructor(board) {
        this.board = board;
        this.daysOff =
            board.days_off.length > 0
                ? board.days_off.split(",").map(it => Number(it))
                : [];
    }
}
let Schedule = class Schedule extends ReactiveComponent {
    constructor() {
        super(...arguments);
        this.unsavedChanges = false;
        this.boards = new Array();
        this.boardsTask = Task.idle();
        this.submitTask = Task.idle();
        this.boardsQueryOptions = {
            query: require("@/apollo/queries/allBoards.graphql")
        };
    }
    created() {
        window.addEventListener("beforeunload", this.beforeUnload);
        this.subscribeQuery({
            tag: "boards",
            options: this.boardsQueryOptions,
            onTask: task => {
                this.boardsTask = task;
                if (task.isSuccessful) {
                    this.boards = task.data.board.map(it => new BoardWithDaysOff(it));
                }
            }
        });
    }
    beforeDestroy() {
        window.removeEventListener("beforeunload", this.beforeUnload);
    }
    beforeUnload(e) {
        if (this.unsavedChanges) {
            e.preventDefault();
            e.returnValue = "";
        }
    }
    beforeRouteLeave(to, from, next) {
        if (this.unsavedChanges) {
            const confirm = window.confirm("Exit page? Changes you made may not be saved.");
            if (!confirm) {
                next(false);
                return;
            }
        }
        next();
    }
    onUpdateDaysOff() {
        this.unsavedChanges = true;
        this.submitTask = this.submitTask.resetIfFinished;
    }
    submit() {
        const boards = this.boards;
        let params = [];
        let mutations = [];
        let variables = {};
        boards.forEach(it => {
            const board = it.board;
            params.push(`$board_${board.id}_id: Int!, $board_${board.id}_input: board_set_input!`);
            mutations.push(`
            update_${board.id}: update_board(
              where: {id: {_eq: $board_${board.id}_id}},
              _set: $board_${board.id}_input
            ) {
              returning {
                ...Board
              }
            }
          `);
            const input = { days_off: it.daysOff.join(",") };
            variables[`board_${board.id}_id`] = board.id;
            variables[`board_${board.id}_input`] = input;
        });
        const boardFragment = require("@/apollo/fragments/board.graphql");
        const updateBoardsDaysOff = `
        mutation updateBoardsDaysOff(${params.join(", ")}) {
          ${mutations.join("\n\n")}
        }
      `;
        this.subscribeMutation({
            tag: "submit",
            options: {
                mutation: gql `
          ${updateBoardsDaysOff}
          ${boardFragment}
        `,
                variables: variables,
                update: (store, { data }) => {
                    console.log(data);
                    try {
                        boards.forEach(it => {
                            const board = it.board;
                            const returningBoard = data[`update_${board.id}`].returning[0];
                            store.writeFragment({
                                id: board.id.toString(),
                                fragment: boardFragment,
                                fragmentName: `Board`,
                                data: returningBoard
                            });
                        });
                    }
                    catch (e) {
                        console.log("Failed to update cache after updateBoardsDaysOff mutation");
                        console.log(e);
                    }
                }
            },
            onTask: async (task) => {
                this.submitTask = task;
                if (this.submitTask.isSuccessful) {
                    this.unsavedChanges = false;
                    await trainingService.updateTrainingsByDate();
                }
            }
        });
    }
};
Schedule = __decorate([
    Component({
        components: { TemplateContent, ScheduleBoard, ProgressButton }
    })
], Schedule);
export default Schedule;
